import { configurePreferences } from "./preferences.js";
import { appKeys, appLinks, appUrl } from "@hlt/contracts";
// src/config/index.ts
const sameOrigin = () => typeof window === "undefined" ? "" : window.location.origin;
let config = {
	serves: ["platform", "fiveS"],
	origins: {
		platform: sameOrigin(),
		fiveS: sameOrigin()
	},
	siteOrigin: sameOrigin(),
	apiOrigin: "",
	inAppPath: (link) => link.path
};
function configureKit(next) {
	config = next;
	const hosts = [...Object.values(next.origins), next.siteOrigin].flatMap((origin) => {
		try {
			return [new URL(origin).hostname];
		} catch {
			return [];
		}
	});
	configurePreferences(hosts);
}
const kitConfig = () => config;
/** Server-provided paths must stay app-relative: no scheme, no protocol-relative host, no backslashes. */
const isAppPath = (path) => path.startsWith("/") && !path.startsWith("//") && !path.includes("\\");
/**
* A link of this bundle becomes a router path; a link of another app becomes its absolute URL. Unknown
* shapes return null, so a notification never links somewhere unexpected.
*/
function resolveLink(link) {
	if (!isAppPath(link.path)) return null;
	if (config.serves.includes(link.app)) {
		const to = config.inAppPath(link);
		return to ? {
			kind: "route",
			to
		} : null;
	}
	return {
		kind: "url",
		href: appUrl(config.origins, link)
	};
}
/**
* Where a sign-out continues: through the signed-out page of every other app (browser storage is per
* origin, so each app clears its own), ending at `final`. Each hop validates `next` with `safeReturn`.
*/
function signedOutRoute(final) {
	return appKeys.filter((app) => !config.serves.includes(app)).reduceRight((next, app) => `${appUrl(config.origins, appLinks.signedOut(app))}?next=${encodeURIComponent(next)}`, final);
}
/** Absolute URL of an API path (`/api/v1/...`). */
const apiUrl = (path) => `${config.apiOrigin.replace(/\/+$/, "")}${path}`;
/** Absolute public-site URL of a path (legal pages and product pages live on the site; help lives in HLT Cloud). */
const siteUrl = (path) => `${config.siteOrigin.replace(/\/+$/, "")}${path}`;
/**
* A validated place to return to after sign-in: a path on this origin (not the API) or an absolute URL
* on a configured app origin. Anything else falls back, so sign-in can never become an open redirect.
*/
function safeReturn(next, fallback) {
	if (!next) return fallback;
	if (next.startsWith("/")) return next.startsWith("//") || next.includes("\\") || next.startsWith("/api/") ? fallback : next;
	try {
		const url = new URL(next);
		const allowed = Object.values(config.origins).map((o) => new URL(o).origin);
		return (url.protocol === "https:" || url.protocol === "http:") && allowed.includes(url.origin) ? url.toString() : fallback;
	} catch {
		return fallback;
	}
}
export { apiUrl, configureKit, kitConfig, resolveLink, safeReturn, signedOutRoute, siteUrl };

//# sourceMappingURL=config.js.map